import axios from 'axios';
import APIS from '../../apis';
import VIPAPI from '@/apis/vip.js'
import qs from 'qs';
import  {callbackHandler} from '../callbackHandler';

export default {
    state: {
        INDEXSCROLLTOP: 0
    },
    mutations: {
        setINDEXSCROLLTOP(state, number) {
            state.INDEXSCROLLTOP = number;
        }
    },
    getters: {},
    actions: {
        //首页获取测评列表接口
        getHighEndIndexScales(context, params){
            console.log(params);
            return axios.get(APIS.getHighEndIndexScales, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getHighEndIndexScales, res);
                return res.data;
            })
        },
        //获取高端产品单条测评的详情接口
        getHighEndScaleDetailIntro(context, params){
            console.log(params);
            return axios.get(APIS.getHighEndScaleDetailIntro, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getHighEndScaleDetailIntro, res);
                return res.data;
            })
        },
        //获取 我的测评列表 (已购买的套餐和测评数据) 接口
        getHighEndMyScaleData(context, params){
            console.log(params);
            return axios.get(APIS.getHighEndMyScaleData, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getHighEndMyScaleData, res);
                return res.data;
            })
        },
        //获取高价测试列表
        getProfessionalScales(context, params){
            return axios.get(APIS.getProfessionalScales, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getProfessionalScales, res);
                return res.data;
            })
        },
        //双12会员活动首页接口
        getVipHomePageInfo(context, params){
            return axios.get(APIS.getVipHomePageInfo, {
                params: params.params
            }).then(function (res) {
                callbackHandler(APIS.getVipHomePageInfo, res);
                return res.data;
            })
        },
        // 购买会员购买礼包
        buyVip(context, params) {
            return axios.get(APIS.vipBuy, {
                params: params.params
            }).then(function(res) {
                callbackHandler(APIS.vipBuy, res);
                return res.data;
            })
        },
        //领取会员红包
        receiveVipCoupon(context, params){
          return axios.get(APIS.receiveVipCoupon, {
              params: params.params
          }).then(function (res) {
              callbackHandler(APIS.receiveVipCoupon, res);
              return res.data;
          })
        },
        //会员红包领取列表
        vipCouponList(context, params){
          return axios.get(APIS.vipCouponList, {
              params: params.params
          }).then(function (res) {
              callbackHandler(APIS.vipCouponList, res);
              return res.data;
          })
        },
        // 会员分销排行榜
        vipDistributionRankingList(context, params) {
          return axios.get(APIS.vipDistributionRankingList, {
            params: params.params
          }).then(function (res) {
            callbackHandler(APIS.vipDistributionRankingList, res);
            return res.data;
          })
        },
        // vip分销活动跳转接口
        fecthVipGetUrl(context, params) {
          return axios.get(APIS.vipGetUrl, {
            params: params.params
          }).then(function (res) {
            callbackHandler(APIS.vipGetUrl, res);
            return res.data;
          })
        },
        //分销页授权接口
        fetchVipDistribution(context, params) {
          return axios.get(APIS.authVipDistribution, {
            params: params.params
          }).then(function (res) {
            callbackHandler(APIS.authVipDistribution, res);
            return res.data;
          })
        },
        //分销页授权接口
        getMyReward(context, params) {
          return axios.get(APIS.getMyReward, {
            params: params.params
          }).then(function (res) {
            // callbackHandler(APIS.getMyReward, res);
            return res;
          })
        },
        //权益页授权接口
        authVipRights(context, params) {
          return axios.get(APIS.authVipRights, {
            params: params.params
          }).then(function (res) {
            callbackHandler(APIS.authVipRights, res);
            return res;
          })
        },
        //获取会员分销卡地址
        getVipDistributionCard(context, params) {
          return axios.get(APIS.getVipDistributionCard, {
            params: params.params
          }).then(function (res) {
            callbackHandler(APIS.getVipDistributionCard, res);
            return res.data;
          })
        },

      // 2022 会员
      // 购买会员购买礼包
      buyVip3(context, params) {
        return axios.get(APIS.vip3Buy, {
          params: params.params
        }).then(function(res) {
          callbackHandler(APIS.vip3Buy, res);
          return res.data;
        })
      },
      getKcVip(context, params) {
        return axios.get(APIS.kcVip, {
          params: params.params
        }).then(function(res) {
          callbackHandler(APIS.kcVip, res);
          return res.data;
        })
      },
      // 双12会员活动首页
      getVip3HomePageInfo(context, params){
        return axios.get(APIS.getVip3HomePageInfo, {
          params: params.params
        }).then(function (res) {
          callbackHandler(APIS.getVip3HomePageInfo, res);
          return res.data;
        })
      },

      // 双12会员活动首页-4.0
      getVip4HomePageInfo(context, params){
        return axios.get(APIS.getVip4HomePageInfo, {
          params: params.params
        }).then(function (res) {
          callbackHandler(APIS.getVip4HomePageInfo, res);
          return res.data;
        })
      },

      receiveUnionVip(context, { env, params, callback } = {}){
        return axios.post(APIS.receiveUnionVip,
            qs.stringify(params)
        ).then(function(res) {
          // console.log(res)
          callbackHandler(APIS.receiveUnionVip, res, callback, true);
          return res.data;
        })
      },
      getUnionVipStatus(context, params){
        return axios.get(APIS.getUnionVipStatus, {
          params: params.params
        }).then(function (res) {
          callbackHandler(APIS.getUnionVipStatus, res);
          return res.data;
        })
      },

      // 2023 会员 vip4.0
      getV4CouponList(context, params) {
        return axios.get(VIPAPI.getV4CouponList, {
          params: params.params
        }).then(function(res) {
          callbackHandler(VIPAPI.getV4CouponList, res);
          return res.data;
        })
      },
      receiveV4Coupon(context, { params, callback } = {}){
        return axios.post(VIPAPI.receiveCoupon,
          qs.stringify(params)
        ).then(function(res) {
          // console.log(res)
          callbackHandler(VIPAPI.receiveCoupon, res, callback, true);
          return res.data;
        })
      },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/vip.js